import { useEffect, useContext } from 'react';
import { default as axios } from '../axiosConfig'
import { useNavigate, useLocation } from 'react-router-dom'; // Added useLocation
import UserContext from '../Contexts/UserContext.js';
import { API_RestoreUserToken, API_UserLogout, API_GetRoleFromId } from '../Assets/ApiUrlContainer.js';

const AuthHandler = () => {
	const { user, setUser } = useContext(UserContext);
	const navigate = useNavigate();
	const location = useLocation(); // Get current route

	// const API_BASE = process.env.REACT_APP_API_URL.includes('://')
	// 	? process.env.REACT_APP_API_URL
	// 	: `http://${process.env.REACT_APP_API_URL}`;

	// const API_URL = `${API_BASE}:${process.env.REACT_APP_API_PORT}/auth/test-token`.replace(/([^:]\/)\/+/g, '$1');

	// Debug: Log the API_URL to make sure it's correct
	console.log('API_URL:', API_RestoreUserToken);

	// Define pages that **do not** require authentication
	const publicRoutes = ['/', '/register', '/forgot-password', '/thank-you', '/thank-you-registration'];

	useEffect(() => {
		// If user is on a public route, **skip session validation**
		if (publicRoutes.includes(location.pathname)) return;

		//  If there's no user, session check isn't needed
		if (!user) return;

		// Add a slight delay before running auth check (prevents interrupting navigation)
		const timer = setTimeout(async () => {
			try {
				console.log('Sending session validation request...');

				const response = await axios.get(API_RestoreUserToken, {
					withCredentials: true,
				});

				console.log('User session valid:', response.data);

				// Ensure the payload contains firstname and lastname
				const { Email, Role, FirstName, LastName } = response.data.payload || {};

				if (!FirstName || !LastName) {
					console.warn('Missing user details in session:', response.data.payload);
				}

				const roleResponse = await axios.get(`${API_GetRoleFromId}/${Role}`);
	  			const roleName =  roleResponse.data.Role.toLowerCase();

				// Update user context with full details
				setUser({
					Email: Email || '',
					Role: roleName || 'unknown',
					FirstName: FirstName ?? 'Unknown',
					LastName: LastName ?? 'User',
					RoleId: Role || 0,
				});
			} catch (error) {
				console.error('Session Invalid:', error.response?.data || error.message);

				// Debug: Log the Axios request details
				console.error('Axios Debug:', {
					url: API_RestoreUserToken,
					headers: error.config?.headers,
					method: error.config?.method,
					withCredentials: error.config?.withCredentials,
				});

				if (error.response?.status === 403) {
					alert('Your account has been locked. Please contact support.');
				}

				// Logout and redirect
				await axios.post(API_UserLogout, {}, { withCredentials: true });

				setUser(null);
				console.log('Redirecting to login...');
				navigate('/'); // Redirect to login page
			}
		}, 1800000); // Delay of 1hr

		return () => clearTimeout(timer);
	}, [user, setUser, navigate, location.pathname]); // Added location.pathname to dependencies

	return null;
};

export default AuthHandler;
